import { z } from 'zod';
/** Undefined (omitted) is a skip; null, empty string, and non-UUIDs are all rejected. */
export const optionalPresentUuidString = (invalidMessage) => z
    .string()
    .nullable()
    .superRefine((value, context) => {
    if (value == null || !z.uuid({ version: 'v7' }).safeParse(value).success) {
        context.addIssue({ code: 'custom', message: invalidMessage, path: [] });
    }
});
//# sourceMappingURL=optional-present-uuid-string.js.map